import loadable from '@loadable/component';

export const MarieclaireukSiteWrapper = loadable(
  () => import(/* webpackChunkName: "marieclaireuk-site" */ './MarieclaireukSiteWrapper'),
);
